
// 表单的单位和范围自动填写默认值

import { message } from "antd"
import { fillInFormPre } from "../../services/data/data"

interface Stack {
  currentIndex: number
  deCodes: string[]
}

// 将list字段分组
export const takeListFields = (body: any[], stack: Stack[], listed = false)=> {
  for(const item of body) {
    if (item.type === 'list') {
      stack.push({
        currentIndex: item.currentIndex,
        deCodes: []
      })
      
      // list类型每个节点相同
      takeListFields(item.children[0].children, stack, true)
    } else if(item.type === 'group') {
      takeListFields(item.children, stack, listed)
    } else {
      if (listed) {
        stack.at(-1)?.deCodes.push(item.deCode)
      }
    }
  }
}

// 已录入的表单 - 单位和范围自动填写默认值
export const presetFill = async (formId: number, body: any[])=> {
  const { code, data } = await fillInFormPre(formId)

  if (code > 0) {
    message.error('获取数据失败')
    return []
  }

  // 存储 list 分组deCode
  const stack: Stack[] = []

  // 将字段按List分组(防止一个表单多个list)
  takeListFields(body, stack)

  const nValues: any[] = []

  const keys = Object.keys(data)
  const values = Object.values(data)

  // 遍历预设字段
  keys.forEach((deCode: string, i)=> {
    // 遍历list(可能同一表单多个list)
    for(const { currentIndex, deCodes } of stack) {
      // 在当前list中
      if (deCodes.includes(deCode)) {
        for(let index=1; index<=currentIndex; index++) {
          nValues.push({
            deCode,
            dataCode: `${deCode}#${index}`,
            value: values[i]
          })
        }
        keys[i] = ''
      }
    }
  })

  // 为空的是list使用过的
  keys.forEach((deCode, i)=> {
    if (deCode) {
      nValues.push({
        deCode,
        dataCode: deCode,
        value: values[i]
      })
    }
  })

  return nValues
}

// 表单list新增节点时
export const presetNewFill = async (formId: number, body: any[])=> {
  const { code, data } = await fillInFormPre(formId)

  if (code > 0) {
    message.error('获取数据失败')
    return []
  }

  // 存储 list 分组deCode
  const stack: Stack[] = []

  // 将字段按List分组(防止一个表单多个list)
  takeListFields(body, stack)

  const nValues: any[] = []

  const keys = Object.keys(data)
  const values = Object.values(data)

  // 遍历预设字段
  keys.forEach((deCode: string, i)=> {
    // 遍历list(可能同一表单多个list)
    for(const { currentIndex, deCodes } of stack) {
      // 在当前list中
      if (deCodes.includes(deCode)) {
        nValues.push({
          deCode,
          dataCode: `${deCode}#${currentIndex + 1}`,
          value: values[i]
        })
      }
    }
  })

  return nValues
}
